import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!

  return (_openBlock(), _createBlock(_component_ion_back_button, {
    mode: "md",
    "default-href": "/home"
  }))
}